import {FuseNavigation} from '../@fuse/types';

export const fuseNavigation: FuseNavigation[] = [
  {
    id: 'applications',
    title: 'Applications',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'home',
        url: '/pages/applications/dashboard',
        hidden: false
      },
      {
        id: 'techops-kpi-collapsable',
        title: 'TechOps KPIs',
        type: 'collapsable',
        icon: 'monitoring',
        hidden: false,
        children: [
          {
            id: 'executive-kpi-dashboard',
            title: 'Metrics LITE',
            type: 'item',
            icon: 'leaderboard',
            url: '/pages/applications/metrics-lite',
            hidden: false
          },
          {
            id: 'techops-kpi-pbi',
            title: 'PowerBI Dashboard',
            type: 'item',
            icon: 'show_chart',
            url: '/pages/applications/pbi-kpi-dashboard',
            hidden: false
          },
        ]
      },
      {
        id: 'tracker',
        title: 'Unit Tracker',
        type: 'item',
        icon: 'notifications_active',
        url: '/pages/applications/unit-tracker',
        badge: {
          title: '0',
          bg: '#F44336',
          fg: '#FFFFFF'
        },
        hidden: false
      },
      {
        id: 'query-builders',
        title: 'Query Builders',
        type: 'collapsable',
        icon: 'query_stats',
        hidden: false,
        children: [
          {
            id: 'discrepancy-query',
            title: 'Discrepancies',
            type: 'item',
            icon: 'find_in_page',
            url: '/pages/applications/query-builders/discrepancy-query',
            hidden: false
          },
          {
            id: 'removal-query',
            title: 'Removals',
            type: 'item',
            icon: 'eject',
            url: '/pages/applications/query-builders/removal-query',
            hidden: false
          },
          {
            id: 'wb-flight-query',
            title: 'Weight & Balance',
            type: 'item',
            icon: 'flight',
            url: '/pages/applications/query-builders/wb-flight-query',
            hidden: false
          },
        ]
      },
      {
        id: 'pain-index',
        title: 'Pain Index',
        type: 'collapsable',
        icon: 'swap_vert',
        hidden: false,
        children: [
          {
            id: 'fleet-pain',
            title: 'Fleet Pain',
            type: 'collapsable',
            hidden: false,
            children: [
              {
                id: 'fleet-pain-trends',
                title: 'Trends',
                type: 'item',
                url: '/pages/applications/pain-index/fleet-pain/trends',
                hidden: false,
              },
              {
                id: 'fleet-pain-by-fleet-ata',
                title: 'By Fleet and ATA',
                type: 'item',
                url: '/pages/applications/pain-index/fleet-pain/by-fleet-ata',
                hidden: false,
              },
              {
                id: 'fleet-pain-by-fleet-ata-chapter',
                title: 'By Fleet and ATA Chapter',
                type: 'item',
                url: '/pages/applications/pain-index/fleet-pain/by-fleet-ata-chapter',
                hidden: false,
              },
              {
                id: 'fleet-pain-by-ata',
                title: 'By ATA',
                type: 'item',
                url: '/pages/applications/pain-index/fleet-pain/by-ata',
                hidden: false,
              },
              {
                id: 'fleet-pain-by-ata-chapter',
                title: 'By ATA Chapter',
                type: 'item',
                url: '/pages/applications/pain-index/fleet-pain/by-ata-chapter',
                hidden: false,
              },
              {
                id: 'fleet-pain-by-acn',
                title: 'By Aircraft Number',
                type: 'item',
                url: '/pages/applications/pain-index/fleet-pain/by-acn',
                hidden: false,
              },
            ],
          },
          {
            id: 'parts-pain',
            title: 'Component Pain',
            type: 'collapsable',
            hidden: false,
            children: [
              {
                id: 'component-pain-trends',
                title: 'Component Pain Trends',
                type: 'item',
                url: '/pages/applications/pain-index/component-pain/trends',
                hidden: true,
              },
              {
                id: 'component-pain-by-overall',
                title: 'By Part Number',
                type: 'item',
                url: '/pages/applications/pain-index/component-pain/by-overall',
                hidden: false,
              },
              {
                id: 'component-pain-by-fleet',
                title: 'By Fleet',
                type: 'item',
                url: '/pages/applications/pain-index/component-pain/by-fleet',
                hidden: false,
              },
              {
                id: 'component-pain-by-fleet-ata',
                title: 'By Fleet and ATA',
                type: 'item',
                url: '/pages/applications/pain-index/component-pain/by-fleet-ata',
                hidden: false,
              },
              {
                id: 'component-pain-by-fleet-ata-chapter',
                title: 'By Fleet and ATA Chapter',
                type: 'item',
                url: '/pages/applications/pain-index/component-pain/by-fleet-ata-chapter',
                hidden: false,
              },
              {
                id: 'component-pain-by-ata',
                title: 'By ATA',
                type: 'item',
                url: '/pages/applications/pain-index/component-pain/by-ata',
                hidden: false,
              },
              {
                id: 'component-pain-by-ata-chapter',
                title: 'By ATA Chapter',
                type: 'item',
                url: '/pages/applications/pain-index/component-pain/by-ata-chapter',
                hidden: false,
              },
            ],
          },
        ]
      },
      {
        id: 'leadership-insights',
        title: 'Leadership Insights',
        type: 'item',
        icon: 'query_stats',
        url: '/pages/applications/leadership-insights',
        badge: {
          title: 'NEW',
          bg: '#FF1493',
          fg: '#FFFFFF'
        },
        hidden: true
      },
    ],
    hidden: false
  },
  {
    id: 'departments',
    title: 'Departments',
    type: 'group',
    children: [
      {
        id: 'component-reliability',
        title: 'Component Reliability',
        type: 'collapsable',
        icon: 'build',
        hidden: false,
        children: [
          {
            id: 'part-lookup',
            title: 'Part Lookup',
            icon: 'search',
            url: '/pages/component-reliability/part-lookup',
            type: 'item',
            hidden: false,
          },
          {
            id: 'part-health',
            title: 'Component Health',
            type: 'item',
            icon: 'timeline',
            url: '/pages/component-reliability/component-health',
            hidden: false
          },
          {
            id: 'history',
            title: 'Life History',
            type: 'item',
            icon: 'history',
            url: '/pages/component-reliability/life-history',
            hidden: false
          },
          {
            id: 'component-projects',
            title: 'CRT Projects',
            type: 'item',
            icon: 'track_changes',
            url: '/pages/component-reliability/component-projects',
            hidden: false
          },
          {
            id: 'component-cases',
            title: 'Component Cases',
            type: 'item',
            icon: 'work_outline',
            url: '/pages/component-reliability/component-cases',
            hidden: false
          },
          {
            id: 'smart-times',
            title: 'Smart Times',
            type: 'item',
            icon: 'alarm',
            url: '/pages/component-reliability/smart-times',
            hidden: false
          },
          {
            id: 'teardown-reports',
            title: 'Teardown Reports',
            icon: 'assignment',
            hidden: false,
            type: 'item',
            url: '/pages/component-reliability/teardown-reports/library',
          },
          {
            id: 'powerbi-reports',
            title: 'PowerBI Reports',
            icon: 'insert_chart_outlined',
            hidden: false,
            type: 'collapsable',
            children: [
              {
                id: 'mtbur',
                title: 'MTBUR',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/mtbur',
                hidden: false
              },
              {
                id: 'praer',
                title: 'PRAER',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/praer',
                hidden: false
              },
              {
                id: 'pbi-vendor-performance',
                title: 'Vendor Performance',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/vendor-performance',
                hidden: false
              },
              {
                id: 'weibull',
                title: 'Weibull',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/weibull',
                hidden: false
              },
              {
                id: 'weibull-dso',
                title: 'Weibull DSO',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/weibull-dso',
                hidden: false
              },
              {
                id: 'pbi-smart-times',
                title: 'Smart Times',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/smart-times',
                hidden: false
              },
              {
                id: 'pbi-check-audit',
                title: 'Check Audit',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/check-audit',
                hidden: false
              },
              {
                id: 'pbi-unhd-grading',
                title: 'Unit Grading',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/unit-grading',
                hidden: false
              },
              {
                id: 'pbi-insourcing',
                title: 'Insourcing',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/insourcing',
                hidden: false
              },
              {
                id: 'pbi-optix-timelines',
                title: 'OPTIX Timelines',
                type: 'item',
                icon: 'pie_chart',
                url: '/pages/component-reliability/embedded-powerbi/optix-timelines',
                badge: {
                  title: 'NEW',
                  bg: '#FF1493',
                  fg: '#FFFFFF'
                },
                hidden: false
              },
              // {
              //   id: 'pbi-sars',
              //   title: 'SAR Review',
              //   type: 'item',
              //   icon: 'pie_chart',
              //   url: '/pages/component-reliability/embedded-powerbi/sar',
              //   badge: {
              //     title: 'NEW',
              //     bg: '#FF1493',
              //     fg: '#FFFFFF'
              //   },
              //   hidden: false
              // },
            ]
          },
          {
            id: 'internal-crt-metrics',
            title: 'Internal Metrics',
            icon: 'equalizer',
            url: '/pages/component-reliability/internal-metrics',
            type: 'item',
            hidden: true,
          },
        ]
      },
      {
        id: 'engineering',
        title: 'Engineering',
        type: 'collapsable',
        icon: 'drafts',
        hidden: false,
        children: [
          {
            id: 'mod-overview',
            title: 'Mod Overview',
            type: 'item',
            icon: 'find_in_page',
            url: '/pages/engineering/mod-overview',
            badge: {
              title: 'NEW',
              bg: '#FF1493',
              fg: '#FFFFFF'
            },
            hidden: true
          },
          {
            id: 'eo-progress',
            title: 'EO Progress',
            type: 'item',
            icon: 'timeline',
            url: '/pages/engineering/eo-progress',
            hidden: false
          },
          {
            id: 'eo-budget-forecast',
            title: 'Budget Forecast',
            type: 'item',
            icon: 'stacked_line_chart',
            url: '/pages/engineering/eo-budget-forecast',
            badge: {
              title: 'NEW',
              bg: '#FF1493',
              fg: '#FFFFFF'
            },
            hidden: true
          },
          {
            id: 'eo-documents',
            title: 'EO Optix Docs',
            icon: 'assignment',
            url: '/pages/engineering/eo-documents',
            type: 'item',
            hidden: false
          },
        ]
      },
      {
        id: 'engineering-support',
        title: 'Engineering Support',
        type: 'collapsable',
        icon: 'supervisor_account',
        hidden: false,
        children: [
          {
            id: 'aes-requests',
            title: 'Request Input',
            type: 'item',
            icon: 'input',
            url: '/pages/engineering-support/aes-requests',
            hidden: false
          },
          {
            id: 'eo-analysis',
            title: 'EO Analysis',
            type: 'item',
            icon: 'assessment',
            url: '/pages/engineering-support/eo-analysis',
            hidden: false
          },
          {
            id: 'ramp-eo-performance',
            title: 'Ramp EO Performance',
            type: 'item',
            icon: 'assessment',
            url: '/pages/engineering-support/ramp-eo-performance',
            hidden: false,
          },
        ]
      },
      {
        id: 'fleet-team',
        title: 'Fleet Team',
        type: 'collapsable',
        icon: 'groups',
        hidden: true,
        children: [
          {
            id: 'one-list',
            title: 'One List',
            type: 'item',
            icon: 'filter_list',
            url: '/pages/fleet-team/one-list/log',
            badge: {
              title: 'NEW',
              bg: '#FF1493',
              fg: '#FFFFFF'
            },
            hidden: false
          },
        ]
      },
      {
        id: 'devops-engineering',
        title: 'DevOps Engineering',
        type: 'collapsable',
        icon: 'architecture',
        hidden: false,
        children: [
          {
            id: 'fleet-statistics-by-fleet',
            title: 'Stats by Fleet',
            type: 'collapsable',
            icon: 'fitness_center',
            hidden: false,
            children: [
              {
                id: 'fleet-statistics-a300',
                title: 'A300',
                type: 'item',
                icon: 'flight',
                url: '/pages/devops-engineering/fleet-statistics/analysis/a300',
                hidden: false
              },
              {
                id: 'fleet-statistics-b757',
                title: 'B757',
                type: 'item',
                icon: 'flight',
                url: '/pages/devops-engineering/fleet-statistics/analysis/b757',
                hidden: false
              },
              {
                id: 'fleet-statistics-b767',
                title: 'B767',
                type: 'item',
                icon: 'flight',
                url: '/pages/devops-engineering/fleet-statistics/analysis/b767',
                hidden: false
              },
              {
                id: 'fleet-statistics-b777',
                title: 'B777',
                type: 'item',
                icon: 'flight',
                url: '/pages/devops-engineering/fleet-statistics/analysis/b777',
                hidden: false
              },
              {
                id: 'fleet-statistics-md11',
                title: 'MD11',
                type: 'item',
                icon: 'flight',
                url: '/pages/devops-engineering/fleet-statistics/analysis/md11',
                hidden: false
              },
            ],
          },
          {
            id: 'fleet-statistics-other',
            title: 'Other Statistics',
            type: 'collapsable',
            icon: 'alt_route',
            hidden: false,
            children: [
              {
                id: 'fleet-statistics-trunk',
                title: 'All Trunk Fleets',
                type: 'item',
                icon: 'flight_takeoff',
                url: '/pages/devops-engineering/fleet-statistics/analysis/trunk',
                hidden: false
              },
              {
                id: 'fleet-statistics-feeder',
                title: 'Feeder Fleets',
                type: 'item',
                icon: 'flight_takeoff',
                url: '/pages/devops-engineering/fleet-statistics/analysis/feeder',
                hidden: false
              },
              {
                id: 'fleet-statistics-custom',
                title: 'Custom Analysis',
                type: 'item',
                icon: 'search',
                url: '/pages/devops-engineering/fleet-statistics/analysis/custom',
                hidden: false
              },
            ],
          },
        ]
      },
      {
        id: 'materiel',
        title: 'Materiel',
        type: 'collapsable',
        icon: 'inventory_2',
        hidden: false,
        children: [
          {
            id: 'shelf-life-expiration',
            title: 'Shelf Life Report',
            type: 'item',
            icon: 'alarm',
            url: '/pages/materiel/shelf-life-expiration',
            badge: {
              title: 'NEW',
              bg: '#FF1493',
              fg: '#FFFFFF'
            },
            hidden: true
          },
          {
            id: 'lobo-report',
            title: 'LOBO Report',
            type: 'item',
            icon: 'credit_card',
            url: '/pages/materiel/lobo-report',
            badge: {
              title: 'NEW',
              bg: '#FF1493',
              fg: '#FFFFFF'
            },
            hidden: true
          },
          {
            id: 'supplier-lookup',
            title: 'Supplier Lookup',
            type: 'item',
            icon: 'search',
            url: '/pages/materiel/supplier-lookup',
            hidden: false
          },
          {
            id: 'supplier-scorecard',
            title: 'Supplier Scorecard',
            type: 'item',
            icon: 'bar_chart',
            url: '/pages/materiel/supplier-scorecard',
            hidden: false
          },
          {
            id: 'psaa-nff-warranty',
            title: 'PSAA Warranty',
            type: 'item',
            icon: 'assignment_return',
            url: '/pages/materiel/psaa-nff-warranty',
            hidden: false
          },
        ]
      },
      {
        id: 'strategic-mx-planning',
        title: 'Strategic MX Planning',
        type: 'collapsable',
        icon: 'fact_check',
        hidden: false,
        children: [
          {
            id: 'opportunity-index',
            title: 'Opportunity Index',
            type: 'item',
            icon: 'sort',
            url: '/pages/strategic-mx-planning/opportunity-index',
            hidden: false
          },
          {
            id: 'moc-rsp',
            title: 'MOC RSP',
            type: 'item',
            icon: 'pin_drop',
            url: '/pages/strategic-mx-planning/moc-rsp',
            hidden: false
          },
        ]
      },
    ],
    hidden: false
  },
  {
    id: 'documentation',
    title: 'Documentation',
    type: 'group',
    children: [
      {
        id: 'faqs',
        title: 'Frequently Asked Questions',
        type: 'item',
        icon: 'help_outline',
        url: '/pages/documentation/faq',
        hidden: false
      },
      {
        id: 'academy',
        title: 'Academy',
        type: 'item',
        icon: 'school',
        url: '/pages/documentation/academy',
        hidden: false,
      },
      {
        id: 'glossary',
        title: 'Glossary',
        type: 'item',
        icon: 'import_contacts',
        url: '/pages/documentation/glossary',
        hidden: false,
      },
      {
        id: 'roadmap',
        title: 'Roadmap',
        type: 'item',
        icon: 'map',
        url: '/pages/documentation/roadmap',
        hidden: false
      },
      {
        id: 'changelog',
        title: 'Changelog',
        type: 'item',
        icon: 'library_books',
        url: '/pages/documentation/changelog',
        hidden: false
      }
    ],
    hidden: false
  },
  {
    id: 'admin',
    title: 'Administration',
    type: 'group',
    children: [
      {
        id: 'files',
        title: 'Files',
        type: 'item',
        icon: 'attachment',
        url: '/pages/admin/files',
        hidden: false
      },
      {
        id: 'metrics',
        title: 'Metrics',
        type: 'item',
        url: '/pages/admin/metrics',
        hidden: false,
        icon: 'graphic_eq'
      },
      {
        id: 'maintenance',
        title: 'Maintenance',
        type: 'item',
        url: '/pages/admin/maintenance',
        hidden: false,
        icon: 'build'
      },
      {
        id: 'notifications',
        title: 'Notifications',
        type: 'item',
        url: '/pages/admin/notifications',
        hidden: false,
        icon: 'notifications'
      },
      {
        id: 'users',
        title: 'Users',
        type: 'item',
        url: '/pages/admin/users',
        hidden: false,
        icon: 'group'
      },
      {
        id: 'user-feedback',
        title: 'Feedback',
        type: 'item',
        url: '/pages/admin/feedback',
        hidden: false,
        icon: 'question_answer'
      },
      {
        id: 'deep-dive-questions-list',
        title: 'Deep Dive Questions',
        type: 'item',
        url: '/pages/admin/deep-dive-questions-list',
        hidden: false,
        icon: 'help'
      },
      {
        id: 'apiKeys',
        title: 'API Keys',
        type: 'item',
        url: '/pages/admin/api-keys',
        hidden: false,
        icon: 'security'
      },
      {
        id: 'testing',
        title: 'Testing',
        type: 'item',
        url: '/pages/admin/testing',
        hidden: false,
        icon: 'bug_report'
      },
    ],
    hidden: true
  },
];

